import { RTN_MSG } from "../utils/emunData";
import { CryptoKey } from "../utils/emunData";
import Crypto from "../utils/crypto";
import {
  httpGet,
  httpPost,
  httpPut,
  httpDelete,
  httpUploadFormData,
} from "../utils/http";

export default class {
  apiEndpoint = null;

  constructor(apiEndpoint) {
    this.apiEndpoint = apiEndpoint;
  }

  createInHospitalIfNeedVer2(inHospitalID, inHospital, optUserID) {
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/inHospital/v2?inHospitalID=${inHospitalID}&optUserID=${optUserID}`;
    return httpPost(apiUrl, inHospital);
  }

  getInHospital(inHospitalID) {
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/inHospital/v2?inHospitalID=${inHospitalID}`;
    return httpGet(apiUrl);
  }
  getBulkInHospital(ids) {
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/inHospital/v2/bulk/read`;
    return httpPost(apiUrl, { ids });
  }
  deleteInHospital(inHospitalID) {
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/inHospital/v2?inHospitalID=${inHospitalID}`;
    return httpDelete(apiUrl);
  }

  createInHospitalPlanVer2(_id, plan, optUserID) {
    const inHospitalID = _id.replace(/\/plan.*$/, "");
    const planDateTime = _id.replace(/^.*\//, "");
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/inHospital/v2/plan?inHospitalID=${inHospitalID}&planDateTime=${planDateTime}&optUserID=${optUserID}`;
    return httpPost(apiUrl, plan);
  }

  updateInHospitalVer2(_id, inHospital, optUserID) {
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/inHospital/v2/main?inHospitalID=${_id}&optUserID=${optUserID}`;
    return httpPut(apiUrl, inHospital);
  }

  deleteInHospitalByPlanDateTimeVer2(_id, planDateTime) {
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/inHospital/v2/plan?inHospitalID=${_id}&planDateTime=${planDateTime}`;
    return httpDelete(apiUrl);
  }

  updateInHospitalPlanVer2(_id, plan, optUserID) {
    const inHospitalID = _id.replace(/\/plan.*$/, "");
    const planDateTime = _id.replace(/^.*\//, "");
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/inHospital/v2/plan?inHospitalID=${inHospitalID}&planDateTime=${planDateTime}&optUserID=${optUserID}`;
    return httpPut(apiUrl, plan);
  }

  getInHospitalMissionLogVer2(_id) {
    const inHospitalID = _id.replace(/\/missionLog.*$/, "");
    const planDateTime = _id.replace(/^.*\//, "");

    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/inHospital/v2/missionLog?inHospitalID=${inHospitalID}&planDateTime=${planDateTime}`;
    return httpGet(apiUrl);
  }

  pushInHospitalMissionLogVer2(_id, executeLog, optUserID) {
    const inHospitalID = _id.replace(/\/missionLog.*$/, "");
    const planDateTime = _id.replace(/^.*\//, "");
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/inHospital/v2/mission/execute?inHospitalID=${inHospitalID}&planDateTime=${planDateTime}&optUserID=${optUserID}`;
    return httpPost(apiUrl, executeLog);
  }

  modifyInHospitalMissionLogVer2(_id, executeLog, optUserID) {
    const inHospitalID = _id.replace(/\/missionLog.*$/, "");
    const planDateTime = _id.replace(/^.*\//, "");
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/inHospital/v2/mission/execute?inHospitalID=${inHospitalID}&planDateTime=${planDateTime}&optUserID=${optUserID}`;
    return httpPut(apiUrl, executeLog);
  }

  deleteInHospitalMissionLogVer2(_id, executeID, optUserID) {
    const inHospitalID = _id.replace(/\/missionLog.*$/, "");
    const planDateTime = _id.replace(/^.*\//, "");
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/inHospital/v2/mission/execute?inHospitalID=${inHospitalID}&planDateTime=${planDateTime}&executeID=${executeID}&optUserID=${optUserID}`;
    return httpDelete(apiUrl);
  }

  createInHospitalExamVer2(
    _id,
    dateTime,
    { petID, recordID, doctorID, doctor },
    examTask,
    examConsumable,
    optUserID
  ) {
    const inHospitalID = _id.replace(/\/exam.*$/, "");
    const planDateTime = _id.replace(/^.*\/exam\//, "").replace(/\/.*$/, "");
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/inHospital/v2/exam?inHospitalID=${inHospitalID}&planDateTime=${planDateTime}&optUserID=${optUserID}`;
    return httpPost(apiUrl, { _id, dateTime, examTask, examConsumable });
  }

  getInHospitalExamVer2(_id) {
    const inHospitalID = _id.replace(/\/exam.*$/, "");
    const planDateTime = _id.replace(/^.*\/exam\//, "").replace(/\/.*$/, "");
    const executeID = _id.replace(/.*\//, "");
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/inHospital/v2/exam?inHospitalID=${inHospitalID}&planDateTime=${planDateTime}&executeID=${executeID}`;
    return httpGet(apiUrl);
  }

  getInHospitalExamByPetVer2(petID, clinic) {
    let clinicID = clinic ? clinic : localStorage.getItem("CLINIC");
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${clinicID}/inHospital/v2/exam/pet?petID=${petID}`;
    return httpGet(apiUrl);
  }

  updateInHospitalExamVer2(_id, dateTime, examTask, examConsumable, optUserID) {
    const inHospitalID = _id.replace(/\/exam.*$/, "");
    const planDateTime = _id.replace(/^.*\/exam\//, "").replace(/\/.*$/, "");
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/inHospital/v2/exam?inHospitalID=${inHospitalID}&planDateTime=${planDateTime}&optUserID=${optUserID}`;
    return httpPut(apiUrl, { _id, dateTime, examTask, examConsumable });
  }

  getTodoInHospitalDrugListVer2(dateBegin = 0) {
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/inHospital/v2/todo/drug?dateBegin=${dateBegin}`;
    return httpGet(apiUrl);
  }

  getTodoInHospitalExamListVer2(dateBegin = 0) {
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/inHospital/v2/todo/exam?dateBegin=${dateBegin}`;
    return httpGet(apiUrl);
  }

  getActiveInHospitalPlanVer2(planDateTime) {
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/inHospital/v2/plan/active?planDateTime=${planDateTime}`;
    return httpGet(apiUrl);
  }

  getActiveInHospitalMissionLogVer2(planDateTime) {
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/inHospital/v2/missionLog/active?planDateTime=${planDateTime}`;
    return httpGet(apiUrl);
  }

  getActiveInHospitalVer2() {
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/inHospital/v2/active`;
    return httpGet(apiUrl);
  }

  getInHospitalListVer2(condition) {
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/inHospital/v2/explore/history`;
    return httpPost(apiUrl, condition);
  }

  uploadInHospitalExamImgVer2(_id, upload) {
    const inHospitalID = _id.replace(/\/exam.*$/, "");
    const planDateTime = _id.replace(/^.*\/exam\//, "").replace(/\/.*$/, "");
    const executeID = _id.replace(/^.*\//, "");

    let photoData = new FormData();
    Object.keys(upload).forEach((key) => {
      photoData.append(key, upload[key]);
    });

    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/inHospital/v2/file/exam?inHospitalID=${inHospitalID}&planDateTime=${planDateTime}&executeID=${executeID}`;
    return httpUploadFormData(apiUrl, photoData);
  }

  deleteInHospitalExamImgVer2(_id, delFileNames) {
    const inHospitalID = _id.replace(/\/exam.*$/, "");
    const planDateTime = _id.replace(/^.*\/exam\//, "").replace(/\/.*$/, "");
    const executeID = _id.replace(/^.*\//, "");

    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/inHospital/v2/file/exam?inHospitalID=${inHospitalID}&planDateTime=${planDateTime}&executeID=${executeID}`;
    return httpDelete(apiUrl, delFileNames);
  }

  uploadInHospitalMissionLogImgVer2(_id, executeID, upload) {
    let inHospitalID;
    let planDateTime;
    if (_id.startsWith("/inHospital/missionLog/")) {
      //downward compatibility v1
      inHospitalID = _id.replace(/\/missionLog/, "");
    } else {
      inHospitalID = _id.replace(/\/missionLog.*$/, "");
      planDateTime = _id.replace(/^.*\/missionLog\//, "").replace(/\/.*$/, "");
    }

    let photoData = new FormData();
    Object.keys(upload).forEach((key) => {
      photoData.append(key, upload[key]);
    });

    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/inHospital/v2/file/mission?inHospitalID=${inHospitalID}&executeID=${executeID}`;

    if (planDateTime) {
      apiUrl += `&planDateTime=${planDateTime}`;
    }
    return httpUploadFormData(apiUrl, photoData);
  }

  deleteInHospitalMissionLogImgVer2(_id, executeID, delFileNames) {
    let inHospitalID;
    let planDateTime;
    if (_id.startsWith("/inHospital/missionLog/")) {
      //downward compatibility v1
      inHospitalID = _id.replace(/\/missionLog/, "");
    } else {
      inHospitalID = _id.replace(/\/missionLog.*$/, "");
      planDateTime = _id.replace(/^.*\/missionLog\//, "").replace(/\/.*$/, "");
    }

    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/inHospital/v2/file/mission?inHospitalID=${inHospitalID}&executeID=${executeID}`;

    if (planDateTime) {
      apiUrl += `&planDateTime=${planDateTime}`;
    }
    return httpDelete(apiUrl, delFileNames);
  }

  updateInHospitalDischargeVer2(inHospitalID, optUserID, dateTime) {
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/inHospital/v2/discharge?inHospitalID=${inHospitalID}`;
    if (optUserID) {
      return httpPut(`${apiUrl}&optUserID=${optUserID}`);
    } else {
      return httpDelete(apiUrl);
    }
  }

  getInHospitalListByPetVer2(petID, clinic) {
    let clinicID = clinic ? clinic : localStorage.getItem("CLINIC");
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${clinicID}/inHospital/v2/explore/pet?petID=${petID}`;
    return httpGet(apiUrl);
  }

  getInHospitalHistoryDrug(petID, inHospitalID, timeRange, page) {
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/inHospital/v2/drug/history?inHospitalID=${
      inHospitalID ? inHospitalID : ""
    }&petID=${petID ? Crypto.encrypt(petID, CryptoKey) : ""}`;
    return httpPost(apiUrl, { timeRange, page });
  }

  disableInHospitalDrug(disableDateTime, inHospitalID, planDateTime, bagID) {
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/inHospital/v2/drug/disable`;
    return httpPost(apiUrl, {
      disableDateTime,
      inHospitalID,
      planDateTime,
      bagID,
    });
  }

  getDisableDrug(inHospitalID) {
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/inHospital/v2/drug/disable?inHospitalID=${inHospitalID}`;
    return httpGet(apiUrl);
  }

  getInHospitalBilling(condition) {
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/inHospital/v2/billing/explore`;
    return httpPost(apiUrl, condition);
  }

  getInHospitalExamListVer2(inHospitalID, planDateTime) {
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/inHospital/v2/exam/list?inHospitalID=${inHospitalID}`;

    if (planDateTime) {
      apiUrl += `&planDateTime=${planDateTime}`;
    }
    return httpGet(apiUrl);
  }

  getInHospitalPlanListVer2(inHospitalID) {
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/inHospital/v2/plan/list?inHospitalID=${inHospitalID}`;
    return httpGet(apiUrl);
  }

  getInHospitalMissionLogListVer2(inHospitalID) {
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/inHospital/v2/missionLog/list?inHospitalID=${inHospitalID}`;
    return httpGet(apiUrl);
  }

  getInHospitalExamDateTime(examIDs) {
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/inHospital/v2/bluk/read/dateTime`;
    return httpPost(apiUrl, examIDs);
  }
}
